import React from 'react';
import classnames from 'classnames';
import { node, func, string, bool } from 'prop-types';
import ButtonIcon from '../icon/button';
import Menu, { MenuWrapper } from '../menu';

const Chip = ({
  children,
  deletable,
  className,
  onRemove,
  ...props
}) => (
  <span
    className={classnames('mdc-chip', { deletable }, className)}
    {...props}
  >
    <span className="mdc-chip__text">{children}</span>
    {deletable && (
      <ButtonIcon
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="cancel"
      >cancel
      </ButtonIcon>
    )}
  </span>
);

Chip.propTypes = {
  children: node.isRequired,
  deletable: bool,
  onRemove: func,
  className: string,
};

Chip.defaultProps = {
  deletable: false,
  onRemove: () => null,
  className: '',
};

const EditableChip = ({
  content,
  menuWrapperRef,
  menuRef,
  onClose,
  ...props
}) => (content
  ? (
    <MenuWrapper
      className="menu__chip"
      ref={menuWrapperRef}
      wrappedElement={
        <Chip
          {...props}
        />
      }
      onClose={onClose}
    >
      <Menu menuRef={menuRef}>
        {React.Children.map(content, child => React.cloneElement(child, {
          onClick: (e) => { e.stopPropagation(); },
        }))}
      </Menu>
    </MenuWrapper>
  )
  : <Chip {...props} />
);

EditableChip.propTypes = {
  content: node,
  onClose: func,
};

EditableChip.defaultProps = {
  content: null,
  onClose: () => null,
};

export default EditableChip;
